import {
	basicBlack,
	grayBorder,
	grayFont,
	green,
	blue
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
	fontSize32,
	gridGutterHalf
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const totalStyle = `
    display: flex;
    align-items: center;
    flex-direction: column;

    h1 {
        font-weight: bold;
        color: ${basicBlack};
        font-size: ${fontSize32};
        span {
            font-size: 75%;
        }
    }

    h5 {
        margin-top: 0;
        margin-bottom: ${gridGutterHalf}px;
        color: ${grayFont};
    }

    hr {
        width: 100%;
        padding-bottom: ${gridGutterHalf}px;
        border: 0;
        border-top: 2px solid ${grayBorder};
        opacity: 0.5;
    }
`;

export const selectStyle = `
    .select-component {
        border-radius: 4px;
        border: 1px solid ${grayBorder};
        .select-component__caret {
            border-top-color: ${green};
        }
        .select-component__selected {
            font-size: 14px;
            font-weight: 500;
            color: ${blue};
        }        
        .select-component__option {
            font-size: 14px;
            font-weight: normal;
            color: ${grayFont};
            border-bottom: 1px solid ${grayBorder};
        }
    }
`;
